export type AsyncAction<Args extends unknown[], Result> = (
    ...args: Args
) => Promise<Result> | Result

export const createSingleFlightRunner = <Args extends unknown[], Result>(
    action: AsyncAction<Args, Result>,
    onRunningChange?: (running: boolean) => void
) => {
    let activePromise: Promise<Result> | null = null

    return (...args: Args): Promise<Result> => {
        if (activePromise) {
            return activePromise
        }

        onRunningChange?.(true)
        activePromise = Promise.resolve(action(...args)).finally(() => {
            activePromise = null
            onRunningChange?.(false)
        })
        return activePromise
    }
}
